import * as yup from "yup"
import { ApolloClient } from "@apollo/client"
import { checkFileName } from "../../../common/validators/checkFileName"
import { Prompt } from "../../../../typings/types"

export type EditablePromptFields = Pick<Prompt, "name">

export const editablePromptFieldsSchema = (params: {
    initialValues: EditablePromptFields
    client: ApolloClient<object>
}): yup.SchemaOf<EditablePromptFields> =>
    yup.object({
        name: yup
            .string()
            .required("Required")
            .test("checkFileName", "Filename already exists", async function test(value) {
                return params.initialValues.name === value || checkFileName(value, params.client)
            })
    })
